import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoCountDown from 'eco-design/elements/eco-count-down';
import EcoEmail from 'eco-design/elements/eco-email';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import moment from 'moment';
import React, { useEffect } from 'react';
import { AnimatedGrid, AnimatedSection } from '../AnimatedSection';
import { useReplaceMap, useTerms } from './conf';
import Modal from './Modal';
import MoreIcon from './MoreIcon';

// 导入动画工具
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import '../AnimatedSection/scroll-animations.scss';
import CloseIcon from './CloseIcon';
import styles from './index.module.scss';
import { useRouter } from 'next/router';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';

interface BannerProps {
    pageType: 'ultra' | 'max';
}

const endTime = new Date(`2025/10/13 15:00:00 GMT+8`).getTime();

const AnimatedSubscribe: React.FC<BannerProps> = ({ pageType }: BannerProps = { pageType: 'max' }) => {
    const { locale } = getLocal();
    const { t } = useLang('Subscribe');

    const [show, setShow] = React.useState(false);
    const [showMore, setShowMore] = React.useState(false);

    const handleCountdownEnd = () => {};
    const terms = useTerms(locale);

    // 读取url上的_timer进行测试判断
    const { query } = useRouter();
    const _timer = query._timer;

    console.log(_timer, '_timer');

    const listToggleMap = {
        us: {
            1: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757736639025-62ufhy-compressed-Frame%202094654358.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758094125359-1fo9uf-compressed-768_light_%E4%BE%A7%E6%BB%91.png',
            },
            2: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1757735597116-1982ez-compressed-sl_rapid%20series/mag%2010000mAh%20%265000mAh(qi2).png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758094140760-7m8igk-compressed-768_light_%E4%BE%A7%E6%BB%91.png',
            },
        },
        ca: {
            1: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758539979716-itdue7-compressed-110.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758540014999-fjgs6k-compressed-110.png',
            },
            2: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758539999267-c4xk2o-compressed-160.png',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758540023928-nwwnbi-compressed-160.png',
            },
        },
    };

    const list = [
        {
            title: t.rich('title1', { highlight: (text: string) => <span className="highlight">{text}</span> }),
            max: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758270755693-xgors4-compressed-1.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758169054989-syvcy1-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758719356119-wtmjnf-compressed-20250910.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758719594593-bni60n-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
        },

        ...(pageType === 'ultra'
            ? [
                  {
                      title: t('title2'),
                      ultra: {
                          pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758719171550-9xksv1-compressed-20250914.jpg',
                          h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758719611788-uhgwyo-compressed-6.jpg',
                      },
                  },
              ]
            : [
                  {
                      title: t('title2'),
                      pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758270775336-y9yloa-compressed-2.jpg',
                      h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758094103451-fg0km4-compressed-768_light_%E4%BE%A7%E6%BB%91.png',
                      togglePc: 'https://websiteoss.ecoflow.com/figma-uploads/1758169247958-ixcoem-compressed-Frame%202094654409.jpg',
                      toggleTitle1: t('toggleTitle1'),
                      toggleDesc1: t('toggleDesc1'),
                      togglePc1: listToggleMap[locale as keyof typeof listToggleMap][1].pc,
                      toggleH51: listToggleMap[locale as keyof typeof listToggleMap][1].h5,
                      toggleTitle2: t('toggleTitle2'),
                      toggleDesc2: t('toggleDesc2'),
                      togglePc2: listToggleMap[locale as keyof typeof listToggleMap][2].pc,
                      toggleH52: listToggleMap[locale as keyof typeof listToggleMap][2].h5,
                  },
              ]),

        {
            title: t('title3'),

            max: {
                pc:
                    locale === 'us'
                        ? 'https://websiteoss.ecoflow.com/figma-uploads/1758270698371-khm4rs-compressed-3.jpg'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1758539866681-qy1khu-compressed-CA.jpg',
                h5:
                    locale === 'us'
                        ? 'https://websiteoss.ecoflow.com/figma-uploads/1758169087558-bgh8au-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg'
                        : 'https://websiteoss.ecoflow.com/figma-uploads/1758539947926-9ahrci-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758719371378-40zeyz-compressed-20250915.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758719633761-fy9zzb-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
        },
        {
            title: t('title4'),
            max: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758270720866-2pgja0-compressed-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758169096684-rkib6g-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758719381774-913h71-compressed-20250916.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758719644952-uv7erq-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
        },
        {
            title: t('title5'),
            max: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758270733239-500aw3-compressed-5.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758169107399-hkx4ei-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
            ultra: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758719394101-0wfnjn-compressed-20250917.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758719653897-31p4eg-compressed-768_light_%E4%BE%A7%E6%BB%91.jpg',
            },
        },
    ];

    const contactListId = React.useMemo(() => {
        const listIdMap = {
            us: ['1309693895'],
            ca: ['1525424752'],
        };

        return listIdMap[locale as keyof typeof listIdMap] || listIdMap[us];
    }, [locale]);

    const isExpired = React.useMemo(() => endTime <= (_timer ? new Date(`${_timer} GMT+8`).getTime() : Date.now()), []);

    const handleShow = () => {
        setShow(true);

        // 埋点信息
        gtm.push({
            event: 'uaEvent',
            event_name: 'terms_confirm',
            button_name: t('footerDesc'),
            url: 'none',
        });
    };

    if (isExpired) {
        return null;
    }

    const { isH5 } = useDeviceDetect();

    useEffect(() => {
        if (isH5) {
            setShowMore(true);
        }
    }, [isH5]);

    const linkMapReplace = useReplaceMap(locale);

    return (
        <div className={styles.Subscribe + ' GtmModuleData-section'} data-section-id="d3m-subscribe">
            {/* 标题部分 - 使用淡入上升动画 */}
            <AnimatedSection variant="fadeInUp" options={{ delay: 200 }} className="d3m-title-common">
                <EcoSectionCommon title={t('title')} />
                <div className="countdown-row">
                    <EcoCountDown endTime={endTime} onCountdownEnd={() => handleCountdownEnd} />
                    <div className="digital-content">
                        <div className="digital-text">{t('day')}</div>
                        <div className="digital-text">{t('hour')}</div>
                        <div className="digital-text">{t('minute')}</div>
                        <div className="digital-text">{t('second')}</div>
                    </div>
                </div>
                <div className="d3m-layout">
                    <EcoEmail
                        contactListId={contactListId}
                        defaultTermsCheck={true}
                        tipsObj={{
                            successTips: 'Subscribe successful.',
                        }}
                        fields={[
                            {
                                id: locale === 'us' ? '4423' : '4424',
                                type: 'single',
                                value: 1,
                                overwrite: true,
                            },
                            {
                                id: '31',
                                type: 'single',
                                value: 1,
                                overwrite: false,
                            },
                            {
                                id: '11150',
                                type: 'multiple',
                                value: pageType === 'ultra' ? [27] : [26],
                                overwrite: false,
                            },
                            {
                                id: '13680',
                                type: 'text',
                                value: moment(new Date()).format('YYYY-MM-DD'),
                                overwrite: false,
                            },
                        ]}
                        needTerms={true}
                    />
                </div>
            </AnimatedSection>

            <div className="d3m-layout">
                {/* 产品卡片列表 - 使用交错动画 */}
                <AnimatedGrid
                    variant="rotateIn"
                    options={{
                        stagger: 0.1,
                        threshold: 0.2,
                        delay: 200,
                    }}
                    className="card-list pc-only"
                    itemClassName="card-item-animated"
                >
                    {list.map((item, index) => {
                        if (index === 1 && pageType === 'max') {
                            return (
                                <div className={`card-item card-item-${index + 1}`} key={index}>
                                    <EcoImg
                                        className="card-item-img"
                                        pc={showMore ? item.togglePc : item.pc}
                                        pad={showMore ? item.togglePc : item.pc}
                                        h5={item.h5}
                                        isOpenLazy={true}
                                    />
                                    {showMore ? (
                                        <div className="text-wrapper text-row-wrapper">
                                            <div className="item-2-title">{item.title}</div>
                                            <div className="text-row1">
                                                <div className="row-1-text">
                                                    <div className="row-title">{item.toggleTitle1}</div>
                                                    <div className="row-desc">{item.toggleDesc1}</div>
                                                </div>
                                                <EcoImg className="row-1-img" pc={item.togglePc1} pad={item.togglePc1} h5={item.toggleH51} isOpenLazy={true} />
                                            </div>
                                            <div className="text-row-divider"></div>
                                            <div className="text-row2">
                                                <div className="row-2-text">
                                                    <div className="row-title">{item.toggleTitle2}</div>
                                                    <div className="row-desc">{item.toggleDesc2}</div>
                                                </div>
                                                <EcoImg className="row-2-img" pc={item.togglePc2} pad={item.togglePc2} h5={item.toggleH52} isOpenLazy={true} />
                                            </div>
                                            {!isH5 && (
                                                <div className="close-icon" onClick={() => setShowMore(false)}>
                                                    <CloseIcon />
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="text-wrapper">
                                            <div className="text-title">{item.title}</div>
                                        </div>
                                    )}

                                    {!showMore && (
                                        <div className="more-icon" onClick={() => setShowMore(!showMore)}>
                                            <MoreIcon />
                                        </div>
                                    )}
                                </div>
                            );
                        }

                        return (
                            <div className={`card-item card-item-${index + 1}`} key={index}>
                                <EcoImg
                                    className="card-item-img"
                                    pc={item[pageType as keyof typeof item].pc}
                                    pad={item[pageType as keyof typeof item].pc}
                                    h5={item[pageType as keyof typeof item].h5}
                                    isOpenLazy={true}
                                />
                                <div className="text-wrapper">
                                    <div className="text-title">{item.title}</div>
                                </div>
                            </div>
                        );
                    })}
                </AnimatedGrid>

                {/* 底部描述 - 使用弹跳进入动画 */}
                <AnimatedSection variant="fadeInUp" options={{ delay: 200 }} className="footer-desc">
                    <span onClick={handleShow}>{t('footerDesc')}</span>
                </AnimatedSection>
            </div>

            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />

            {/* 模态框 - 使用缩放进入动画 */}
            <Modal
                className={styles.TermsModal}
                onCancel={() => {
                    setShow(false);
                }}
                open={show}
            >
                <div className="modal-title">{t('modal_title')}</div>
                <div className="modal-content">
                    {terms[pageType].split('\n').map((item, index) => {
                        if (Number.isInteger(+item.trim()[0])) {
                            return (
                                <p key={index} className="title">
                                    {item.trim()}
                                </p>
                            );
                        }
                        if (item.trim().startsWith('xi')) {
                            return (
                                <p key={index} className="sub-sub-title">
                                    {item.trim().slice(1)}
                                </p>
                            );
                        }
                        return (
                            <p
                                key={index}
                                className="sub-title"
                                dangerouslySetInnerHTML={{
                                    __html: linkMapReplace[pageType].reduce((acc, curr) => {
                                        return acc.replaceAll(curr.source, `<a href="${curr.href}" target="_blank" rel="noreferrer">${curr.source}</a>`);
                                    }, item.trim()),
                                }}
                            ></p>
                        );
                    })}
                </div>
            </Modal>
        </div>
    );
};

export default AnimatedSubscribe;
